/* Tom's River Information — sparklines only. Values are server-rendered;
   this file never writes a number the page depends on. */
(function () {
  'use strict';

  /* One green for every sparkline (Bradley 2026-07-28). The style guide used to
     grey out a "steady" line, but the trend is already stated in words beside the
     chart, so the colour was redundant encoding — and it made a steady river look
     like a disabled chart next to a falling one. */
  var SPARK_LINE = '#2f7d3f';
  var AXIS = { cream: '#e3d9c6', label: '#b3ab99' };

  function draw(container) {
    var script = container.querySelector('[data-tri-history]');
    var svg = container.querySelector('svg');
    if (!script || !svg) return;

    var history;
    try { history = JSON.parse(script.textContent); } catch (e) { return; }
    if (!Array.isArray(history)) return;

    // 30 days at every width (Bradley 2026-07-27 — was cropped to 7 on mobile).
    // A week of a slowly-falling river reads as a flat line; the month shows the
    // shape, and ~11px per point is still comfortably legible on a phone.
    var windowDays = 30;
    var points = history
      .filter(function (h) { return typeof h.v === 'number'; })
      .slice(-windowDays);
    if (points.length < 3) return; // sparkline needs >= 3 points

    /* Extend the line to the live reading (Bradley 2026-08-06). The daily
       series only ever reaches yesterday, so without this the chart ends a day
       behind the number printed above it — on a rising river that reads as a
       flat line beside a much larger headline figure.

       Display only: the stored history and the CSV archive stay strictly daily
       (ADR-0014). The live point REPLACES a same-day daily value rather than
       sitting beside it, and the window still spans 30 days. It is flagged so
       the tooltip can say so — it is an instantaneous reading, not a 9am daily
       figure, and the two are not quite like for like. */
    var liveAttr = container.getAttribute('data-tri-live');
    if (liveAttr) {
      var lp = null;
      try { lp = JSON.parse(liveAttr); } catch (e) { lp = null; }
      if (lp && typeof lp.v === 'number' && lp.d) {
        if (points.length && points[points.length - 1].d === lp.d) {
          points = points.slice(0, -1);
        } else {
          points = points.slice(-(windowDays - 1));
        }
        points = points.concat([{ d: lp.d, v: lp.v, live: true }]);
      }
    }

    var label = container.closest('.tri-spark').querySelector('[data-tri-spark-label]');
    if (label) label.textContent = points.length + ' days';

    var colour = SPARK_LINE;
    var axisColour = container.getAttribute('data-axis') || AXIS.cream;
    var tickColour = container.getAttribute('data-tick') || AXIS.label;
    var strokeWidth = container.getAttribute('data-stroke') || '2';

    var w = svg.clientWidth || 600;
    var h = svg.clientHeight || 56;
    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);
    svg.innerHTML = '';

    var vs = points.map(function (p) { return p.v; });
    var min = Math.min.apply(null, vs);
    var max = Math.max.apply(null, vs);

    /* fixed scale (e.g. Tumut 0–9500 ML/day = "height vs full"); axis grows
       beyond the cap only if the data does */
    var yMax = Number(container.getAttribute('data-y-max'));
    if (yMax > 0) {
      min = 0;
      max = Math.max(yMax, max);
    }
    var span = max - min || 1;

    /* left gutter carries the y-axis increment labels (max / mid / min) */
    var gutter = 40;
    var padTop = 5;
    var padBottom = 5;
    var plotLeft = gutter + 4;
    var plotRight = w - 2;
    var plotTop = padTop;
    var plotBottom = h - padBottom;

    var plotted = points.map(function (p, i) {
      return {
        x: plotLeft + (i / (points.length - 1)) * (plotRight - plotLeft),
        y: plotBottom - ((p.v - min) / span) * (plotBottom - plotTop),
        d: p.d,
        v: p.v,
        live: p.live === true,
      };
    });
    var path = plotted.map(function (p, i) {
      return (i === 0 ? 'M' : 'L') + p.x.toFixed(1) + ' ' + p.y.toFixed(1);
    }).join(' ');

    var ns = 'http://www.w3.org/2000/svg';

    function fmt(v) {
      var r = Math.round(v);
      return r >= 10000 ? (r / 1000).toFixed(1).replace(/\.0$/, '') + 'k' : String(r);
    }

    function tick(value, y, anchorY) {
      var t = document.createElementNS(ns, 'text');
      t.setAttribute('x', gutter - 4);
      t.setAttribute('y', y);
      t.setAttribute('text-anchor', 'end');
      t.setAttribute('dominant-baseline', anchorY);
      t.setAttribute('fill', tickColour);
      t.setAttribute('font-size', '9');
      t.textContent = fmt(value);
      svg.appendChild(t);
    }

    /* faint L-shaped axes: left + bottom hairlines, recessive */
    var axes = document.createElementNS(ns, 'path');
    axes.setAttribute(
      'd',
      'M' + gutter + ' ' + plotTop + ' L' + gutter + ' ' + plotBottom + ' L' + plotRight + ' ' + plotBottom
    );
    axes.setAttribute('stroke', axisColour);
    axes.setAttribute('stroke-width', '1');
    axes.setAttribute('fill', 'none');
    svg.appendChild(axes);

    tick(max, plotTop, 'hanging');
    tick(min + span / 2, (plotTop + plotBottom) / 2, 'middle');
    tick(min, plotBottom, 'auto');

    var line = document.createElementNS(ns, 'path');
    line.setAttribute('d', path);
    line.setAttribute('stroke', colour);
    line.setAttribute('stroke-width', strokeWidth);
    line.setAttribute('stroke-linecap', 'round');
    line.setAttribute('stroke-linejoin', 'round');
    line.setAttribute('fill', 'none');
    svg.appendChild(line);

    /* hover state: faint dots on every day + a solid dot and date/value tip
       that track the nearest day under the cursor */
    var dots = document.createElementNS(ns, 'g');
    dots.setAttribute('fill', colour);
    dots.setAttribute('opacity', '0');
    plotted.forEach(function (p) {
      var c = document.createElementNS(ns, 'circle');
      c.setAttribute('cx', p.x.toFixed(1));
      c.setAttribute('cy', p.y.toFixed(1));
      c.setAttribute('r', '1.6');
      c.setAttribute('opacity', '0.35');
      dots.appendChild(c);
    });
    svg.appendChild(dots);

    var hoverDot = document.createElementNS(ns, 'circle');
    hoverDot.setAttribute('r', '3.5');
    hoverDot.setAttribute('fill', colour);
    hoverDot.setAttribute('display', 'none');
    svg.appendChild(hoverDot);

    container.__tri = {
      plotted: plotted,
      plotLeft: plotLeft,
      plotRight: plotRight,
      unit: container.getAttribute('data-unit') || '',
      dots: dots,
      hoverDot: hoverDot,
    };
    bindHover(container, svg);
  }

  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  function tipText(p, unit) {
    var parts = p.d.split('-'); /* 2026-07-26 */
    var date = Number(parts[2]) + ' ' + MONTHS[Number(parts[1]) - 1];
    var value = unit === '%'
      ? p.v.toFixed(1) + '% full'
      : Math.round(p.v).toLocaleString('en-AU') + ' ' + unit;
    return date + ' · ' + value + (p.live ? ' · live' : '');
  }

  function bindHover(container, svg) {
    if (container.__triBound) return;
    container.__triBound = true;
    container.style.position = 'relative';

    var tip = document.createElement('div');
    tip.className = 'tri-spark__tip';
    tip.style.display = 'none';
    container.appendChild(tip);

    svg.addEventListener('pointermove', function (evt) {
      var s = container.__tri;
      if (!s || !s.plotted.length) return;
      var rect = svg.getBoundingClientRect();
      var x = evt.clientX - rect.left;
      var ratio = (x - s.plotLeft) / (s.plotRight - s.plotLeft);
      var i = Math.round(ratio * (s.plotted.length - 1));
      i = Math.max(0, Math.min(s.plotted.length - 1, i));
      var p = s.plotted[i];

      s.dots.setAttribute('opacity', '1');
      s.hoverDot.setAttribute('cx', p.x.toFixed(1));
      s.hoverDot.setAttribute('cy', p.y.toFixed(1));
      s.hoverDot.removeAttribute('display');

      tip.textContent = tipText(p, s.unit);
      tip.style.display = 'block';
      var crect = container.getBoundingClientRect();
      var svgLeft = rect.left - crect.left;
      var svgTop = rect.top - crect.top;
      var tipX = svgLeft + x + 14;
      var flip = tipX + tip.offsetWidth + 8 > container.clientWidth;
      if (flip) tipX = svgLeft + x - 14 - tip.offsetWidth;
      tip.style.left = tipX + 'px';
      tip.style.top = (svgTop + p.y - tip.offsetHeight / 2) + 'px';
    });

    svg.addEventListener('pointerleave', function () {
      var s = container.__tri;
      if (s) {
        s.dots.setAttribute('opacity', '0');
        s.hoverDot.setAttribute('display', 'none');
      }
      tip.style.display = 'none';
    });
  }

  function init() {
    document.querySelectorAll('[data-tri-spark]').forEach(draw);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 200);
  });

  /* theme editor re-renders the section without re-running this script —
     redraw the sparklines when that happens */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
  }
})();
